import * as yup from 'yup';

import { IInputControllerSecondStage, ISecondStageValuesCushingV2 } from './SecondStage.types';
import { IOption } from '../../../../../../shared/ui/form/select/Select.types';
import { ICheckboxConfig } from '../../../../../../shared/ui/form/checkboxes/Checkboxes.types';

export const currentRecognitionEtopicACTHProductionSyndromeOptions: IOption[] = [
  {
    label: 'Rak drobnokomórkowy płuca',
    value: 'Rak drobnokomórkowy płuca'
  },
  {
    label: 'Rakowiak typowy płuca',
    value: 'Rakowiak typowy płuca'
  },
  {
    label: 'Rakowiak atypowy płuca',
    value: 'Rakowiak atypowy płuca'
  },
  {
    label: 'Rak rdzeniasty tarczycy',
    value: 'Rak rdzeniasty tarczycy'
  },
  {
    label: 'Guz chromochłonny',
    value: 'Guz chromochłonny'
  },
  {
    label: 'Nowotwór neuroendokrynny trzustki',
    value: 'Nowotwór neuroendokrynny trzustki'
  },
  {
    label: 'Nowotwór neuroendokrynny przewodu pokarmowego',
    value: 'Nowotwór neuroendokrynny przewodu pokarmowego'
  },
  {
    label: 'Nowotwór neuroendokrynny grasicy',
    value: 'Nowotwór neuroendokrynny grasicy'
  },
  {
    label: 'Brak ustalonego źródła choroby',
    value: 'Brak ustalonego źródła choroby'
  },
  {
    label: 'Inny',
    value: 'Inny'
  }
];

export const currentRecognitionAdrenalCushingSyndromeOptions: IOption[] = [
  {
    label: 'gruczolak nadnercza',
    value: 'gruczolak nadnercza'
  },
  {
    label: 'rak nadnercza',
    value: 'rak nadnercza'
  },
  {
    label: 'obustronny makroguzkowy rozrost kory nadnerczy',
    value: 'obustronny makroguzkowy rozrost kory nadnerczy'
  },
  {
    label: 'obustronny mikroguzkowy rozrost kory nadnerczy',
    value: 'obustronny mikroguzkowy rozrost kory nadnerczy'
  }
];

export const currentCushingSpecializationOptions: IOption[] = [
  {
    label: 'Endokrynolog',
    value: 'Endokrynolog'
  },
  {
    label: 'Lekarz rodzinny',
    value: 'Lekarz rodzinny'
  },
  {
    label: 'Internista',
    value: 'Internista'
  },
  {
    label: 'Okulista',
    value: 'Okulista'
  },
  {
    label: 'Neurolog',
    value: 'Neurolog'
  },
  {
    label: 'Kardiolog',
    value: 'Kardiolog'
  },
  {
    label: 'Ortopeda',
    value: 'Ortopeda'
  },
  {
    label: 'Reumatolog',
    value: 'Reumatolog'
  },
  {
    label: 'PACJENT / rodzina',
    value: 'Pacjent / rodzina'
  },
  {
    label: 'Inne',
    value: 'Inne'
  }
];

export const macroAdenomaKnospScaleOptions: IOption[] = [
  {
    label: '0',
    value: '0'
  },
  {
    label: 'I',
    value: 'I'
  },
  {
    label: 'II',
    value: 'II'
  },
  {
    label: 'III',
    value: 'III'
  },
  {
    label: 'IV',
    value: 'IV'
  }
];

export const otherMethodsTkArrayCheckboxesConfig: ICheckboxConfig[] = [
  {
    label: 'klatki piersiowej',
    name: 'klatki piersiowej',
    size: 4
  },
  {
    label: 'jamy brzusznej i miednicy',
    name: 'jamy brzusznej i miednicy',
    size: 6
  },
  {
    label: 'nadnerczy',
    name: 'nadnerczy',
    size: 2
  }
];

export const validationSecondStageSchema = yup.object().shape({
  hormonalTestDuringTheDiagnosisCortisol: yup.string().when('hormonalTestDuringTheDiagnosisCortisolCheckbox', {
    is: (value: boolean) => value === true,
    then: schema => schema.required('Pole jest wymagane')
  }),
  hormonalTestDuringTheDiagnosisCortisolEvening: yup.string().when('hormonalTestDuringTheDiagnosisCortisolEveningCheckbox', {
    is: (value: boolean) => value === true,
    then: schema => schema.required('Pole jest wymagane')
  }),
  hormonalTestDuringTheDiagnosisCortisolDeks: yup.string().when('hormonalTestDuringTheDiagnosisCortisolDeksCheckbox', {
    is: (value: boolean) => value === true,
    then: schema => schema.required('Pole jest wymagane')
  }),
  hormonalTestDuringTheDiagnosisACTH: yup.string().when('hormonalTestDuringTheDiagnosisACTHCheckbox', {
    is: (value: boolean) => value === true,
    then: schema => schema.required('Pole jest wymagane')
  }),
  hormonalTestDuringTheDiagnosisFreeCortisol: yup.string().when('hormonalTestDuringTheDiagnosisFreeCortisolCheckbox', {
    is: (value: boolean) => value === true,
    then: schema => schema.required('Pole jest wymagane')
  }),
  hormonalTestDuringTheDiagnosisMLNSC: yup.string().when('hormonalTestDuringTheDiagnosisMLNSCCheckbox', {
    is: (value: boolean) => value === true,
    then: schema => schema.required('Pole jest wymagane')
  }),
  hormonalTestDuringTheDiagnosisCRH: yup.string().when('hormonalTestDuringTheDiagnosisCRHCheckbox', {
    is: (value: boolean) => value === true,
    then: schema => schema.required('Pole jest wymagane')
  }),
  hormonalTestDuringTheDiagnosisDesmopressin: yup.string().when('hormonalTestDuringTheDiagnosisDesmopressinCheckbox', {
    is: (value: boolean) => value === true,
    then: schema => schema.required('Pole jest wymagane')
  }),
  hormonalTestDuringTheDiagnosisDexamethasone: yup.string().when('hormonalTestDuringTheDiagnosisDexamethasoneCheckbox', {
    is: (value: boolean) => value === true,
    then: schema => schema.required('Pole jest wymagane')
  })
});

export const initialSecondStage: ISecondStageValuesCushingV2 = {
  currentDiagnosisCushing: '',
  currentDiagnosisProductionACTHCheck: '',
  currentDiagnosisProductionACTHOther: '',
  currentDiagnosisAdrenalCushingCheck: '',
  courseDateStart: null,
  courseWhoRecognized: '',
  hormonalTestDuringTheDiagnosisCortisolIsActive: false,
  hormonalTestDuringTheDiagnosisCortisol: '',
  hormonalTestDuringTheDiagnosisCortisolEveningIsActive: false,
  hormonalTestDuringTheDiagnosisCortisolEvening: '',

  hormonalTestDuringTheDiagnosisCortisolDeksIsActive: false,
  hormonalTestDuringTheDiagnosisCortisolDeks: '',
  hormonalTestDuringTheDiagnosisACTH: '',
  hormonalTestDuringTheDiagnosisACTHIsActive: false,
  hormonalTestDuringTheDiagnosisFreeCortisol: '',
  hormonalTestDuringTheDiagnosisFreeCortisolIsActive: false,
  hormonalTestDuringTheDiagnosisMLNSC: '',
  hormonalTestDuringTheDiagnosisMLNSCIsActive: false,
  hormonalTestDuringTheDiagnosisCRH: '',
  hormonalTestDuringTheDiagnosisCRHIsActive: false,
  hormonalTestDuringTheDiagnosisDesmopressin: '',
  hormonalTestDuringTheDiagnosisDesmopressinIsActive: false,
  hormonalTestDuringTheDiagnosisDexamethasone: '',
  hormonalTestDuringTheDiagnosisDexamethasoneIsActive: false,
  imagingResultMrTkMacroMicroadenoma: '',
  imagingResultMrTkOther: '',
  imagingResultMrTkMacroadenomaInfiltration: '',
  infiltrationLeftActive: false,
  infiltrationRightActive: false,
  infiltrationScaleRight: '',
  infiltrationScaleLeft: '',

  otherMethodsTkActive: false,
  otherMethodsTkArray: [],
  otherMethodsTkDescription: '',
  otherMethodsTkFiles: null,
  otherMethodsTkFileslink: '',
  otherMethodsSomatostatinActive: false,
  otherMethodsSomatostatinResult: '',
  otherMethodsSomatostatinFiles: null,
  otherMethodsSomatostatinFileslink: '',

  otherMethods68PETActive: false,
  otherMethods68PETResult: '',
  otherMethods68PETFiles: null,
  otherMethods68PETFileslink: '',

  otherMethods18PETActive: false,
  otherMethods18PETResult: '',
  otherMethods18PETFiles: null,
  otherMethods18PETFileslink: '',

  otherMethodsOtherActive: false,
  otherMethodsOtherArray: [
    {
      otherMethod: '',
      otherMethodFiles: null,
      otherMethodFileslink: ''
    }
  ],

  confirmationOfSomatotropicTissueMaterial: false,
  proliferationMarkerKi67: '',
  electronMicroscopicExamination: '',

  pancreaticNeuroendocrineTumor: '',
  otherPancreaticNeuroendocrineTumor: '',
  acthIndependentCushingSyndrome: ''
};

export const checkboxInputControllerConfig: IInputControllerSecondStage = {
  currentDiagnosisCushing: false,
  currentDiagnosisProductionACTHCheck: false,
  currentDiagnosisAdrenalCushingCheck: false,
  hormonalTestDuringTheDiagnosisCortisol: false,
  hormonalTestDuringTheDiagnosisCortisolEvening: false,
  hormonalTestDuringTheDiagnosisCortisolDeks: false,
  hormonalTestDuringTheDiagnosisACTH: false,
  hormonalTestDuringTheDiagnosisFreeCortisol: false,
  hormonalTestDuringTheDiagnosisMLNSC: false,
  hormonalTestDuringTheDiagnosisCRH: false,
  hormonalTestDuringTheDiagnosisDesmopressin: false,
  hormonalTestDuringTheDiagnosisDexamethasone: false,
  imagingResultMrTkMacroadenomaInfiltration: false,
  imagingResultMrTkOther: false,
  infiltrationScaleLeft: false,
  infiltrationScaleRight: false
};

export const convertInputControllerSecondStage = (secondStage: ISecondStageValuesCushingV2) => {
  return {
    currentDiagnosisCushing: secondStage.currentDiagnosisCushing !== '',
    currentDiagnosisProductionACTHCheck: secondStage.currentDiagnosisProductionACTHCheck !== '',
    currentDiagnosisAdrenalCushingCheck: secondStage.currentDiagnosisAdrenalCushingCheck !== '',
    hormonalTestDuringTheDiagnosisCortisol: secondStage.hormonalTestDuringTheDiagnosisCortisol !== '',
    hormonalTestDuringTheDiagnosisCortisolEvening: secondStage.hormonalTestDuringTheDiagnosisCortisolEvening !== '',
    hormonalTestDuringTheDiagnosisCortisolDeks: secondStage.hormonalTestDuringTheDiagnosisCortisolDeks !== '',
    hormonalTestDuringTheDiagnosisACTH: secondStage.hormonalTestDuringTheDiagnosisACTH !== '',
    hormonalTestDuringTheDiagnosisFreeCortisol: secondStage.hormonalTestDuringTheDiagnosisFreeCortisol !== '',
    hormonalTestDuringTheDiagnosisMLNSC: secondStage.hormonalTestDuringTheDiagnosisMLNSC !== '',
    hormonalTestDuringTheDiagnosisCRH: secondStage.hormonalTestDuringTheDiagnosisCRH !== '',
    hormonalTestDuringTheDiagnosisDesmopressin: secondStage.hormonalTestDuringTheDiagnosisDesmopressin !== '',
    hormonalTestDuringTheDiagnosisDexamethasone: secondStage.hormonalTestDuringTheDiagnosisDexamethasone !== '',
    imagingResultMrTkOther: secondStage.imagingResultMrTkOther !== '',
    imagingResultMrTkMacroadenomaInfiltration: secondStage.imagingResultMrTkMacroadenomaInfiltration !== '',
    infiltrationScaleLeft: secondStage.infiltrationScaleLeft !== '',
    infiltrationScaleRight: secondStage.infiltrationScaleRight !== ''
  };
};
